<template>
  <section class="aroma-pay-section" aria-label="支付方式">
    <h2>支付方式</h2>
    <button
      v-for="(item, index) in cashiers"
      :key="item.id"
      type="button"
      class="aroma-pay-section__row"
      @click="$emit('select', index)"
    >
      <van-icon
        :name="payIcon(item)"
        :color="getPayType(item) === 'wechat' ? '#07c160' : '#1677ff'"
        size="25"
        :aria-label="payName(item)"
      />
      <span>{{ payName(item) }}</span>
      <van-icon
        :name="index === selectedIndex ? 'checked' : 'circle'"
        :color="index === selectedIndex ? '#596afd' : '#c8c9cc'"
        size="22"
      />
    </button>
    <div v-if="cashiers.length === 0" class="aroma-pay-section__empty">当前环境暂无可用支付方式</div>
  </section>
</template>

<script>
import { getPayType } from '@/utils/aroma-shop'

export default {
  name: 'AromaPaySection',

  props: {
    cashiers: {
      type: Array,
      default: () => []
    },
    selectedIndex: {
      type: Number,
      default: 0
    }
  },

  methods: {
    getPayType,

    payName (item) {
      return getPayType(item) === 'wechat' ? '微信支付' : '支付宝'
    },

    payIcon (item) {
      return getPayType(item) === 'wechat' ? 'wechat' : 'alipay'
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-pay-section {
  margin-top: 12px;
  background: #fff;

  h2 {
    min-height: 46px;
    padding: 0 16px;
    color: #1f2329;
    font-size: 15px;
    font-weight: 500;
    line-height: 46px;
    border-bottom: 1px solid #eee;
  }

  &__row {
    display: flex;
    width: 100%;
    min-height: 52px;
    align-items: center;
    padding: 0 16px;
    color: #1f2329;
    background: #fff;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    touch-action: manipulation;

    span {
      flex: 1;
      margin-left: 10px;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }
  }

  &__empty {
    min-height: 52px;
    padding: 0 16px;
    color: #8a8f98;
    font-size: 14px;
    line-height: 52px;
  }
}
</style>
